// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"12a904cb","239":"bb1e2b45","453":"07a6ab98","455":"246fe479","685":"c3115b4a","959":"262f547b","977":"ad71a753"}[chunkId] + ".chunk.js";
};